import React from 'react';
import { DTOrderSearchView } from '../../DTOrderSearchView';

const DTSelectAmazonOrderNode = () => {
  return <DTOrderSearchView hideNextButton={true} />;
};
export default DTSelectAmazonOrderNode;
